// Public API for organization feature

// Hooks
export {
	useOrganizations,
	useBillingOrganizationId,
	OrganizationsProvider,
} from './hooks/useOrganizations';

// Server actions
export {
	acceptOrganizationInvite,
	inviteUserToOrganization,
	getOrganizationMembers,
	getOrganizationInvitations,
	removeOrganizationMember,
	updateMemberRole,
	updateMemberStatus,
	deleteOrganizationInvitation,
	resendOrganizationInvitation,
	updateOrganization,
	listProviderKeys,
	addProviderKey,
	deleteProviderKey,
	validateProviderKey,
} from './actions/organization-actions';

// Types
export type {
	InvitationStatus,
	MemberStatus,
	OrgType,
	Organization,
	OrganizationInvitation,
	OrganizationInviteData,
	OrganizationMember,
	OrganizationRole,
	ProviderKey,
	ProviderKeyProvider,
	ProviderKeyStatus,
	UserOrganizationWithRole,
} from './types/organization.type';

// Utils
export { organizationInviteStorage } from './utils/organization-invite-utils';
export { organizationStorage } from './utils/organization-storage';
export { canManageBilling } from './utils/org-permissions';
export type { OrgRole } from './utils/org-permissions';

// NOTE: organizationService is not exported to prevent bundling server-only code in client components
// Import directly from './api/organization-service' in server-side code (API routes, server actions)
